import type { FC } from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

import type { HelmetProps } from './types'

const HelmetLayout: FC<HelmetProps> = ({ children, title }) => {
  const { t } = useTranslation()

  return (
    <>
      <Helmet>
        <title>{t(title)}</title>
      </Helmet>

      {children}
    </>
  )
}

export default HelmetLayout
